<template>

  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInline.product_search" placeholder="请输入产品名称/sku条形码"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-input v-model="formInline.op_user_search" placeholder="请输入前端编辑人员昵称"></el-input>
        </el-form-item>

        
        <el-form-item label="">
          <el-input v-model="formInline.op_shop_user_search" placeholder="请输入后端编辑人员昵称"></el-input>
        </el-form-item>
     
     
       <el-form-item label="类型">
          <el-select size="small" v-model="formInline.code" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="销售" value="sold"></el-option>
            <el-option label="一物一码同步" value="sync"></el-option>
            <el-option label="盘点" value="check"></el-option>
        
          </el-select>
        </el-form-item>
  
        <el-form-item label="增加/减少">
          <el-select size="small" v-model="formInline.type" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="增加" :value="1"></el-option>
            <el-option label="减少" :value="2"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" style="background: #c6c6c6;border: none;" @click="reast">重置</el-button>
          <el-button type="primary" style="background: #57cc65;border: none;"  v-if="product_sku_id > 0" 
            @click="gotoBack">返回上一页</el-button>
          
          <!-- <el-button type="primary" @click="sync('barcode')">同步出货记录</el-button> -->
          <!-- <el-button type="primary" @click="sync('salesperson')">同步业务员</el-button>
          <el-button type="primary" @click="sync('user')">同步用户</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="sku_stock_id" label="ID" > </el-table-column>

            <el-table-column prop="product.product_no" label="产品条形码" > </el-table-column>
            <el-table-column prop="product.product_name" label="产品名称" > </el-table-column>
            <el-table-column prop="product.product_sku.product_no" label="产品SKU条形码" > </el-table-column>
            <el-table-column prop="product.product_sku.product_attr" label="产品规格" > </el-table-column>
            


             
            <el-table-column prop="code" label="类型" > 
              <template slot-scope="scope">
                <span v-if="scope.row.code=='sold'">销售</span>
                <span v-if="scope.row.code=='sync'">一物一码同步</span>
                <span v-if="scope.row.code=='check'">盘点</span>

            </template>
            </el-table-column>
            
            <el-table-column prop="type" label="增加/减少" > 
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">增加库存</span>
                <span v-if="scope.row.type==2">减少库存</span>

            </template>
            </el-table-column>

            <el-table-column prop="original_num" label="原库存" >
              <template slot-scope="scope" >
                <span  style="font-size: 16px; ">{{ scope.row.original_num }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="change_num" label="变动库存" >
              <template slot-scope="scope"  >
        
                <span v-if="scope.row.type==1" style="font-size: 16px; color: #006846;">+{{ scope.row.change_num }}</span>
                <span v-if="scope.row.type==2" style="font-size: 16px;color: #ff0000;">{{ scope.row.change_num }}</span>
              </template>
            </el-table-column>

            
            <el-table-column prop="num" label="最终库存" >
              <template slot-scope="scope">
                <span style="font-size: 16px; ">{{ scope.row.num }}</span>
          

              </template>
            </el-table-column>

    
            <el-table-column prop="opUser.nickName" label="前端最后编辑人员"></el-table-column>
            <el-table-column  label="后端最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opShopUser &&  scope.row.opShopUser.user_name">{{ scope.row.opShopUser.user_name }}
                <span v-if=" scope.row.opShopUser.real_name">({{ scope.row.opShopUser.real_name }})</span>
                </div>
              </template>
              </el-table-column>

              <el-table-column prop="remark" label="备注" > </el-table-column>

              <el-table-column prop="update_time" label="最后修改时间" ></el-table-column>
 
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
 
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <Edit :open_edit="open_edit" :id="id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Sync :open_psin="open_psin" :id="psin_id"  v-if="open_psin"   @close="closeSync"></Sync>
  </div>
</template>

<script>
import PsinApi from '@/api/psin.js';
import Edit from './edit.vue';
import Sync from './sync.vue';
export default {
  components: {
    Edit,
    Sync,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_sync_product:-1,
        op_shop_user_search:"",
        op_user_search:""
      },
      app_id:"",

      open_edit:false,
      id:0,

      open_psin:false,
      psin_id:0,
      product_sku_id:0,


    };
  },
  created() {
    console.log('r',this.$route.query.product_sku_id);
    if(this.$route.query.product_sku_id){
      this.formInline.product_search = this.$route.query.product_sku_id
      this.product_sku_id = this.$route.query.product_sku_id
    }
    /*获取列表*/
    this.getTableList();
  },
  methods: {
      /*返回上一页面*/
      gotoBack(){
      this.$router.back(-1);
    },
    reast(){
      this.formInline = {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_sync_product:-1,
        op_shop_user_search:"",
        op_user_search:""
      }
      this.getTableList();
    },
    editClick(id){
      this.open_edit = true;
      this.id = id;
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },

    syncClick(id){
      this.open_psin = true;
      this.psin_id = id;
    },
    closeSync(e){
      this.open_psin=false;
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      PsinApi.skuStock(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },
    sync(code){
        //跳转同步页面
        if(this.app_id.length <= 0){
          this.$message({
              message: '系统错误，请稍后再试',
              type: 'success'
            });  
          return;
        }
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let url = baseUrl + '/job/ApiSync/run?app_id='+this.app_id+"&code="+code;
        window.open(url)
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/psin/index/skustock.vue